import { Instance, SnapshotOut, types } from "mobx-state-tree"
import { BaseModelStoreProps } from "../base-model-store/base-model-store"
import { withEnvironment } from "../extensions/with-environment"
import { withRootStore } from "../extensions/with-root-store"
import { withBaseModel } from "../extensions/with-base-model"
import { getGeneralApiProblem } from "../../services/api/api-problem"

/**
 * Model description here for TypeScript hints.
 */
const OccupationStoreProps = {
  ...BaseModelStoreProps,
  occupations: types.optional(types.array(types.frozen()),[]),
}
export const OccupationStoreModel = types
  .model("OccupationStore")
  .props(OccupationStoreProps)
  .extend(withEnvironment)
  .extend(withRootStore)
  .extend(withBaseModel)
  .views((self) => ({})) // eslint-disable-line @typescript-eslint/no-unused-vars
  .actions((self) => ({
    set(key: keyof typeof OccupationStoreProps, value: any) {
      if (self[key] === value) return
      self[key] = value as never;
    },
    init(){
      self.initModel();
      this.getOccupations().catch();
    },
    async getOccupations() {
      const { appStore } = self.rootStore
      const locale = appStore.locale || 'id'
      const params = { per_page: 1000 }
      this.set('loading', true);
      const result: any = await self.apiSauce.get("/occupations", params, {
        headers: {
          'Accept-Language': locale
        }
      })
      this.set('loading', false);
      if (result.status === 200) {
        const { data } = result.data;
        this.set('occupations', data)
        this.set('error', null)
      } else {
        // __DEV__&& console.tron.log(result.status)
        // self.setNews(null)
        this.set('error', getGeneralApiProblem(result))
      }
    }
  }))

type OccupationStoreType = Instance<typeof OccupationStoreModel>
export interface OccupationStore extends OccupationStoreType {}
type OccupationStoreSnapshotType = SnapshotOut<typeof OccupationStoreModel>
export interface OccupationStoreSnapshot extends OccupationStoreSnapshotType {}
export const createOccupationStoreDefaultModel = () => types.optional(OccupationStoreModel, {})
